import { render } from "./TopWeekCardsComp.vue?vue&type=template&id=4d16397a&scoped=true&ts=true"
import script from "./TopWeekCardsComp.vue?vue&type=script&lang=ts"
export * from "./TopWeekCardsComp.vue?vue&type=script&lang=ts"

import "./TopWeekCardsComp.vue?vue&type=style&index=0&id=4d16397a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d16397a"]])

export default __exports__